'use client';

import { useRef } from 'react';

import { Client } from './client';
import { Hero, ScrollToContactCardProvider } from './components';

export const RetraiteClientWrapper = () => {
  const contactCardRef = useRef<HTMLDivElement>(null);
  const scrollToContactCard = () => {
    if (contactCardRef.current) {
      contactCardRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <ScrollToContactCardProvider scrollToContactCard={scrollToContactCard}>
      <Hero />
      <Client contactCardRef={contactCardRef} />
    </ScrollToContactCardProvider>
  );
};
